import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import CountUp from 'react-countup';
import './Counter.scss';

const Counter = () => (
    <section className="counter">
        <Container>
            <Row className="counter-row">
                <Col md={3} data-aos="zoom-in-up" data-aos-duration="1500">
                    <h1>
                        <CountUp delay={2} decimals={1} end={5.6} />k
                    </h1>
                    <p>Potential Employees</p>
                </Col>
                <Col
                    md={3}
                    className="counter-accuracy"
                    data-aos="zoom-in-up"
                    data-aos-duration="1500"
                >
                    <h1>
                        <CountUp delay={3} end={99} />%
                    </h1>
                    <p>Accuracy Rate</p>
                </Col>
                <Col
                    md={3}
                    className="counter-experience"
                    data-aos="zoom-in-up"
                    data-aos-duration="1500"
                >
                    <h1>
                        <CountUp delay={4} end={10} />+
                    </h1>
                    <p>Years Experience</p>
                </Col>
                <Col md={3} data-aos="zoom-in-up" data-aos-duration="1500">
                    <h1>
                        <CountUp delay={2} decimals={1} end={2.5} />+
                    </h1>
                    <p>World Wide Clients</p>
                </Col>
            </Row>
        </Container>
    </section>
);

export default Counter;
